export default __webpack_public_path__ + "static/media/met-before-after-submitted-mobile-bg.60414223.webp";